import { forwardRef } from 'react';

import { URLQueryParamNames } from '@src/types/urlQueryParamNames';

import Checkbox from '@helsenorge/designsystem-react/components/Checkbox';

interface Props {
  filters: Record<string, boolean>;
  fagomraade: { displayname: string; value: string };
  fagomraderValgt: string[];
  setFagomraderValgt: (arr: string[]) => void;
  setDelayedFilter: (key: string, val: string) => void;
}

const FagomradeDropdown = forwardRef<HTMLInputElement, Props>(
  ({ filters, fagomraade, fagomraderValgt, setFagomraderValgt, setDelayedFilter }, ref) => {
    const keyBase = `${URLQueryParamNames.Fagomrade.toLowerCase()}-${fagomraade.displayname}`;

    return (
      <Checkbox
        key={keyBase}
        inputId={`${keyBase}-${fagomraade.value}`}
        label={fagomraade.displayname}
        value={fagomraade.displayname}
        checked={filters && !!filters[keyBase]}
        ref={ref}
        onChange={e => {
          setFagomraderValgt(
            e.target.checked
              ? [...fagomraderValgt, fagomraade.value].filter((v, i, a) => a.indexOf(v) === i)
              : fagomraderValgt.filter(v => v !== fagomraade.value)
          );
          setDelayedFilter(keyBase, e.target.checked ? e.target.value : '');
        }}
      />
    );
  }
);

FagomradeDropdown.displayName = 'FagomradeDropdown';

export default FagomradeDropdown;
